export default __webpack_public_path__ + "static/media/introImage.a8fc10d6.svg";